import ClassHandler from './components/class.js'; 
import SpaceHandler from './components/space.js'; 
import AccordionHandler from './components/accordion.js'; 
import AnnouncementsHandler from './components/announcements.js'; 
import TeamHandler from './components/team.js';
import MenuHandler from './components/menu.js';
import BGVideoHandler from './components/bg_video.js';
import VideoHandler from './components/video.js';
import FiltersHandler from './components/filters.js';
import SelectHandler from './components/select.js';

ClassHandler();
SpaceHandler();
AccordionHandler();
AnnouncementsHandler();
TeamHandler();
MenuHandler();
BGVideoHandler();
VideoHandler();
FiltersHandler();
SelectHandler();